import { UntypedFormControl } from '@angular/forms';
import { StringUtils } from '../utils/string.utils';

//PMID field accepts 1-8 digits, not only an 8-digit string
export function validatePmidFormat(control: UntypedFormControl) {
    const pmidFormat = control.value as string;
    if (pmidFormat && !pmidFormat.match(StringUtils.regexPmid)) {
        return {
            validatePmidFormat: 'research.status.pmid.error.default.default',
        };
    }
    return null;
}
